/**
 * FLMarquee — a glass band of display caps that scrolls on a loop, separated
 * by small purple dots (v1.71). Hover pauses it; a phrase under the pointer
 * narrows and lights purple. Decorative (the same facts are on the page as
 * text), so it is hidden from screen readers. Reduced motion: a still band.
 * tone="green" is the accent band (a purple wash, light purple caps).
 *
 *   <FLMarquee items={['Fair odds', 'Expected value', 'Best book']} />
 */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { IS_WEB } from '../../utils/motion';
import { ensureFloodlight } from './floodlightCss';
import { FL, display } from './theme';

export default function FLMarquee({ items, size = 56, duration = 36, reverse = false, tone = 'ink', style }) {
    if (IS_WEB) ensureFloodlight();
    const accent = tone !== 'ink';
    const fg = accent ? FL.greenInk : FL.ink;
    const bg = accent ? FL.greenWash : FL.card;
    const dot = accent ? FL.blueInk : FL.green;
    const run = (copy) => items.map((t) => (
        <View key={`${copy}-${t}`} style={styles.item}>
            <Text style={[display(size, { width: 104 }), { color: fg, lineHeight: Math.round(size * 1.1), letterSpacing: -size * 0.02 }]} dataSet={{ flMqItem: '' }}>{t}</Text>
            <View style={[styles.dot, { backgroundColor: dot, width: Math.max(6, size * 0.16), height: Math.max(6, size * 0.16) }]} />
        </View>
    ));
    return (
        <View style={[styles.band, { backgroundColor: bg }, IS_WEB && styles.blur, style]} dataSet={{ flMarquee: tone }} aria-hidden>
            <View
                style={styles.track}
                dataSet={{ flMqTrack: '', flMqDir: reverse ? 'rev' : 'fwd' }}
                {...(IS_WEB ? { style: [styles.track, { animationDuration: `${duration}s` }] } : {})}
            >
                {run('a')}
                {run('b')}
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    band: { overflow: 'hidden', paddingVertical: 14, borderTopWidth: 1, borderBottomWidth: 1, borderColor: FL.hair },
    blur: { backdropFilter: 'blur(18px) saturate(140%)', WebkitBackdropFilter: 'blur(18px) saturate(140%)' },
    track: { flexDirection: 'row', alignItems: 'center' },
    item: { flexDirection: 'row', alignItems: 'center', gap: 28, paddingRight: 28 },
    dot: { borderRadius: 999 },
});
